module.exports = __webpack_public_path__ + "media/img/testimonial/kanthan_jay_sk_hall-097eda8569b847877cd248d58e6182d3.jpeg";